// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  --gt-generic-padding: 0;
  --gt-wrapper-padding: 0;
  --gt-content-min-width: 1350px;
  --gt-scrollbar-width: 1440px;
  --gt-scrollbar-height: 1px;
  --gt-max-width: none;
  --gt-margin: 0;
  max-width: var(--gt-max-width);
  margin: var(--gt-margin);
}
:host.hidden {
  visibility: hidden;
  height: 0;
  overflow: hidden;
  display: block;
}

.generic-table {
  padding: var(--gt-generic-padding);
}

.table-wrapper {
  padding: var(--gt-wrapper-padding);
}

.table-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  overflow-x: scroll;
}
@media screen and (max-width: 1025px) {
  .table-wrapper {
    overflow-x: visible !important;
  }
}

.table-content {
  min-width: var(--gt-content-min-width);
  overflow-x: hidden;
}

.scrollbar-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 10px;
  background-color: #f0f0f0;
  overflow-x: auto;
  overflow-y: hidden;
  z-index: 100;
}
@supports (-webkit-touch-callout: none) {
  .scrollbar-container {
    bottom: 10px;
  }
}
.scrollbar-container::-webkit-scrollbar {
  background: #f0f0f0;
  height: 10px;
}
.scrollbar-container::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(36, 36, 36, 0.8);
}
.scrollbar-container::-webkit-scrollbar-corner {
  display: none;
  height: 0;
  width: 0;
}
@media screen and (max-width: 1025px) {
  .scrollbar-container {
    display: none !important;
  }
}

.scrollbar-content {
  width: var(--gt-scrollbar-width);
  height: var(--gt-scrollbar-height);
}

.end-of-list {
  height: 1px;
  position: relative;
  z-index: 99;
  display: block;
  top: -200px;
  left: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
